import { render } from "./GalleryGridAnnotationReviewItem.vue?vue&type=template&id=2144e8da&scoped=true"
import script from "./GalleryGridAnnotationReviewItem.vue?vue&type=script&lang=js"
export * from "./GalleryGridAnnotationReviewItem.vue?vue&type=script&lang=js"

import "./GalleryGridAnnotationReviewItem.vue?vue&type=style&index=0&id=2144e8da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2144e8da"]])

export default __exports__